import { defineStore } from 'pinia';
import type { INomenclature, IRule, ICalculation } from '@/types/common';
import { ref } from 'vue';
import * as packService from '@/api/dictionaryService';

export const useDataStore = defineStore('dataStore', () => {
  const preloader = ref<boolean>(false);
  const nomenclatures = ref<INomenclature[]>([]);

  const rules = ref<IRule[]>([]);
  const defaultRule = ref<IRule | null>(null);

  const calculationId = ref<number | null>(null);
  const calculation = ref<ICalculation | null>(null);

  const setNomenclatures = (data: INomenclature[]) => {
    nomenclatures.value = data;
  };

  const setRules = (data: IRule[]) => {
    rules.value = data;
  };

  const setDefaultRule = (data: IRule | null) => {
    defaultRule.value = data;
  };

  const loadMainData = async (): Promise<void> => {
    try {
      preloader.value = true;
      const [rulesResp, nomenclatureResp] = await Promise.all([
        packService.getRules(),
        packService.getNomenclature(),
      ]);
      preloader.value = true;
      setRules(rulesResp.data);
      setNomenclatures(nomenclatureResp.data);
    } catch (error: any) {
      preloader.value = true;
    }
  };

  const setCalculation = (data: ICalculation | null) => {
    calculation.value = data;
  };

  const setCalculationId = (calcId: number | null) => {
    calculationId.value = calcId;
  };

  const reset = () => {
    setNomenclatures([]);
    setRules([]);
    setDefaultRule(null);
    setCalculation(null);
    setCalculationId(null);
  };

  return {
    nomenclatures,
    setNomenclatures,
    defaultRule,
    rules,
    setRules,
    setDefaultRule,
    loadMainData,
    calculation,
    setCalculation,
    calculationId,
    setCalculationId,
    reset,
  };
});
